import { render, staticRenderFns } from "./PractitionerComplaints.vue?vue&type=template&id=6471ee5f&scoped=true&"
import script from "./PractitionerComplaints.vue?vue&type=script&lang=js&"
export * from "./PractitionerComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471ee5f",
  null
  
)

export default component.exports